<div id="content" class="allcp-form" ng-controller="CustomerOrderAnalyticController" ng-init="init()">
    <div ng-include="'modules/customer/partials/top_menu.html'"></div>
    <div ng-include="'modules/customer/partials/order_filter_menu.html'"></div>
    <div class="row mt20">
        <div class="col-md-12 mb20">
            <div class="panel date-range">
                <div class="panel-body" >
                    
                    <div class="row">
                        <div class="col">
                            <div class="panel panel-tile border-chart text-center">
                                <div class="panel-body p20">
                                    <h2 class="mbn mtn text-dark">{{ data.count.total?data.count.total:0 }} </h2>
                                </div>
                                <div class="panel-footer p12">
                                    <strong>Total Orders</strong>
                                </div>
                            </div>
                        </div>

                        <div class="col" ng-repeat="item in data.workSteps">
                            <div class="panel panel-tile border-chart text-center">
                                <div class="panel-body p20">
                                    <h2 class="mbn mtn text-dark">{{ data.count.chart[$index] }} </h2>
                                </div>
                                <div class="panel-footer p12">
                                    <strong>{{item.name}}</strong>
                                </div>
                            </div>
                        </div>
                        

                        <div class="col">
                            <div class="panel panel-tile border-chart text-center">
                                <div class="panel-body p20">
                                    <h2 class="mbn mtn text-dark">  {{ (data.count.delivery_time / 60) | number : 0 }} min</h2>
                                </div>
                                <div class="panel-footer p12">
                                    <strong>Delivery Time</strong>
                                </div>
                            </div>
                        </div>
                    
<!-- 
                        <div class="col-md-3">
                            <div class="panel panel-tile border-chart text-center">
                                <div class="panel-body">
                                    <h3 class="mbn mtn text-dark">{{ data.count.rate?data.count.rate:0 }} </h3>
                                </div>
                                <div class="panel-footer p12">
                                    <strong>PuanlananKargo</strong>
                                </div>
                            </div>
                        </div>
     -->
                        <!--
                        <div class="col-md-2">
                            <div class="panel panel-tile border-chart text-center">
                                <div class="panel-body">
                                    <h3 class="mbn mtn text-dark">{{ data.count.distance?data.count.distance:0 }} </h3>
                                </div>
                                <div class="panel-footer p12">
                                    <strong>Toplam KM</strong>
                                </div>
                            </div>
                        </div>
                        -->
                    </div>
                    <hr>
                    <!-- <div class="row">
                        <div class="col-md-12">
                            <div class="progress">
                                <div 
                                    class="progress-bar progress-bar-success progress-bar-striped" 
                                    role="progressbar" 
                                    aria-valuenow="{{ (100 - ((100 * data.count.fail) / data.count.total)).toFixed(2) }}"
                                    aria-valuemin="0" 
                                    aria-valuemax="100" 
                                    ng-style="{ width: (100 - ((100 * data.count.fail) / data.count.total)).toFixed(2) + '%'}">
                                    {{ (100 - ((100 * data.count.fail) / data.count.total)).toFixed(2) }}% Success Rate
                                </div>
                            </div>
                        </div>
                    </div>
                    <hr> -->
                    <div class="row">
                        <div class="col-md-6">
                            <canvas id="doughnut" class="chart chart-doughnut"
                                ng-if="chartData"
                                chart-data="chartData" 
                                chart-labels="series"
                                chart-legend="true" 
                                >
                            </canvas> 
                        </div>
                        <div class="col-md-6">
                            <canvas id="line" class="chart chart-line" 
                                chart-data="barChartData"
                                chart-labels="data.chart.labels"
                                chart-series="series"
                                chart-colours="lineColors"
                                chart-legend="true" 
                                >
                            </canvas>
                        </div>
                    </div>
                    <hr>
                    <div ng-include="'modules/customer/partials/orders.html'"></div>

                </div>
            </div>
        </div>
    </div>
</div>
